import { RootState } from '../types/store.type';

export const authTokenSelector = (state: RootState) => state.auth.token;

export const userRoleSelector = (state: RootState) => state.auth.userRole;

export const userPartnersSelector = (state: RootState) =>
  state.auth.userPartners;
